import { Divider, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { pluralize } from '@/utils/string';

import { SelectedItemsBox } from './selectionPanel/selectedItemsBox';

import { SearchBar } from '../search/searchBar';

export const AddValuesPanel = ({
  entityName,
  selectionEntityName,
  addedValues,
  onAddClick,
  renderItem,
  itemKey,
  onRemove,
  clearAll,
}: {
  entityName: string;
  /** Names what the added-items count holds, where the full entity name reads as a reminder. Defaults to `entityName`. */
  selectionEntityName?: string;
  addedValues: string[];
  onAddClick: (value: string[]) => void;
  renderItem: (item: string) => React.ReactNode;
  itemKey: (item: string) => string;
  onRemove: (item: string) => void;
  clearAll: () => void;
}) => {
  const [input, setInput] = useState('');

  return (
    <Stack
      className='max-h-[480px] overflow-hidden'
      sx={{
        marginTop: '12px',
      }}
    >
      <Typography
        variant='body1'
        sx={{
          padding: '12px 24px',
        }}
      >
        {`Add one or more ${pluralize(entityName)}`}
      </Typography>
      <Stack
        divider={<Divider />}
        sx={{
          gap: '12px',
          overflow: 'hidden',
        }}
      >
        <Stack
          sx={{
            padding: '0 24px 12px',
          }}
        >
          <SearchBar
            value={input}
            setValue={setInput}
            placeholder={entityName}
            selectedValues={addedValues}
            onAddClick={onAddClick}
            showAddButton={true}
            hideSearchIcon={true}
          />
        </Stack>
        {addedValues.length > 0 && (
          <SelectedItemsBox
            items={addedValues}
            entityType={selectionEntityName ?? entityName}
            renderItem={renderItem}
            itemKey={itemKey}
            onRemove={onRemove}
            clearAll={clearAll}
          />
        )}
      </Stack>
    </Stack>
  );
};
